export default "__VITE_ASSET__CUiJQYlm__"